import { createRef, useEffect } from 'react'

export const BackdropLoading = (props: { visible: boolean }) => {
    const ref = createRef<HTMLDialogElement>()

    useEffect(() => {
        if (props.visible) {
            ref.current?.showModal()
        } else {
            ref.current?.close()
        }
    }, [props.visible])

    return (
        <dialog className="modal z-[999]" ref={ref}>
            <div className="modal-box !w-[90px] !bg-[rgba(0,0,0,0.1)] !overflow-hidden !bg-none">
                <span className="loading loading-ring !text-white loading-lg"></span>
            </div>
        </dialog>
    )
}
